module.exports = __webpack_public_path__ + "static/media/questionMark.1376b030.svg";